<template>
  <div id="document">
    <Header></Header>
    <!-- <Navi currentPage="download" :naviHeight="naviH"></Navi> -->
    <div class="main_doc" id="main">
        <!-- <Doc :paras="paras" class="doc"></Doc> -->
        <div class="cont">
            <h2 style="color: #006652;">1000G Phase1 v3 Shapeit2 Reference (2010-11 data freeze, 2013-09 haplotypes)</h2>
            <Table :headers="download_head" :records="hg19_1kg_p1v3" class="download_table"></Table>
            <p>NOTE: The phased genotypes are compiled from <a href="http://www.sph.umich.edu/csg/abecasis/MACH/download/1000G.2013-09.html">Li Yun's MACH</a> website!</p>
            <h2 style="color: #006652;">1000G Phase3 v5 Shapeit2 Reference (hg19)</h2>
            <Table :headers="download_head" :records="hg19_1kg_p3v5" class="download_table"></Table>
            <p>NOTE: The release contains haplotypes on 2,504 samples (#haplotypes = 5,008) for total ~81.2M polymorphic markers released in 2014-09.
Unfortunately, there are less common variants than the above Phase1 V3. The phased genotypes are compiled from <a href="ftp://ftp-trace.ncbi.nih.gov/1000genomes/ftp/release/20130502/">1000 Genomes Project</a> website!</p>
            <h2 style="color: #006652;">1000G Phase3 v5 Shapeit2 Reference (hg38)</h2>
            <Table :headers="download_head" :records="hg38_1kg_p3v5" class="download_table"></Table>
            <p>NOTE: The phased genotypes are compiled from <a href="http://ftp.1000genomes.ebi.ac.uk/vol1/ftp/data_collections/1000_genomes_project/release/20190312_biallelic_SNV_and_INDEL">1000 Genomes Project</a> website!</p>

            <h2 style="color: #006652;">Disclaimer</h2>
            <p>The genotype data is free of charge. All materials on the website are provided without any warranty. 
                Please use them at your own risk.</p>
            <h2 style="color: #006652;">Updates</h2>
            <div v-for="rec of updates">
                <div class="update_title">
                    <img :src="updateImg" class="update_ico"><p>{{rec[0]}}</p>
                </div>
                <div class="update_content">
                    <p>{{rec[1]}}</p>
                </div>
            </div>
            <h2 style="color: #006652;">Contact us</h2>
            <p>We'd love to hear from you! To provide feedback or ask a question, contact us on 
                <a href="mailto:limx54@163.com">limx54@163.com</a>.</p>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
// import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import Table from '@/components/table.vue'
import UpdateImg from '@/assets/img/update.png'

import {api_dir} from '@/bus.js'
import axios from 'axios/dist/axios.min';
// import EleDoc from '@/components/eledoc.vue'
var com_str='<a style="color:#006652;" href="https://mailsysueducn-my.sharepoint.com/:u:/g/personal/limiaoxin_mail_sysu_edu_cn'
export default {
    name: 'download',
    components: {Footer,Header,Table},
    data:function(){
        return {
            download_head:['Population','File'],
            hg19_1kg_p1v3:[
                ['AFR (246 subjects)',com_str+'/EcPnMZOTNUFKpIhpVn_pfFQBK4mCk4y40Y7nqFdm4MisgA?e=tfzqyc">1kg.phase1.v3.shapeit2.afr.tar</a>'],
                ['AMR (181 subjects)',com_str+'/EfYRdvpsQ9lAg4f_3kzdHksB5YDU0xiICGVTwY3ULYJEHQ?e=es3fWT">1kg.phase1.v3.shapeit2.amr.tar</a>'],
                ['ASN (286 subjects)',com_str+'/EdQVwt23ERVLl4Jq9e_PR6UBZ3TIlSHRepi71i4nf5ZlDQ?e=qhfR9b">1kg.phase1.v3.shapeit2.asn.tar</a>'],
                ['EUR (379 subjects)',com_str+'/EaqysqY58WdDu-Z7aPvEBq8BerUoBxvLUfrQGqR4amx7mQ?e=6If8uC">1kg.phase1.v3.shapeit2.eur.tar</a>'],               
            ],
            hg19_1kg_p3v5:[
                ['AFR (645 subjects)',com_str+'/EVK4s64t9ZNPtz9TMTXWpSIBQF4X6T7JVPV-Kh9vxtWCyA?e=8b4FMu">1kg.phase3.v5.shapeit2.afr.hg19.tar.gz</a>'],
                ['AMR (346 subjects)',com_str+'/EQIMGEOTZ-hOm-kLvNRO0f8BZYPqyOdDYw_tI1PrLbCMEw?e=VJcVuP">1kg.phase3.v5.shapeit2.amr.hg19.tar.gz</a>'],
                ['EAS (497 subjects)',com_str+'/EYVYoVquRn5OkiOTGcGAE7kBUkWC2AZTdogFDcXGye1xlw?e=KghK5N">1kg.phase3.v5.shapeit2.eas.hg19.tar.gz</a>'],
                ['EUR (495 subjects)',com_str+'/EX3QjiLqqeRJstahO2Fvhl4BXj5jcda5Bi7nl82qvM9eoQ?e=JxAuFk">1kg.phase3.v5.shapeit2.eur.hg19.tar.gz</a>'],     
                ['SAS (486 subjects)',com_str+'/EXqbbc3F1XVOj47QR3dcoesBNjlrkdCI7Y5j805MB968lg?e=Fm4n6b">1kg.phase3.v5.shapeit2.sas.hg19.tar.gz</a>'],               
            ],
            hg38_1kg_p3v5:[
                ['AFR (660 subjects)',com_str+'/EeAyVVyo54tMiFZeLb7A3yMBUcJjk9_0dBJjzXq0Xe7M3Q?e=ohr2ih">1kg.phase3.v5.shapeit2.afr.hg38.tar.gz</a>'],
                ['AMR (347 subjects)',com_str+'/EV1EU6EwcYRHsTWZnS61cl8BOBQ_cxRLcdsdte-nVr9D_g?e=Awgv27">1kg.phase3.v5.shapeit2.amr.hg38.tar.gz</a>'],
                ['EAS (504 subjects)',com_str+'/ER-diCblZWZLnjwA726TqzUBqgr9IhnPACA1q2kH-7rDzQ?e=QFe7tQ">1kg.phase3.v5.shapeit2.eas.hg38.tar.gz</a>'],
                ['EUR (503 subjects)',com_str+'/ERmqr9dicrlCpFzonp4WLKkBDJIrc1ILQ3D31XjYOw4lJg?e=aFjUYt">1kg.phase3.v5.shapeit2.eur.hg38.tar.gz</a>'],   
                ['SAS (489 subjects)',com_str+'/EYwdmBcRFEJGuK2vE9jGJtsB01EKSHCa41hAQgHTcXR8FA?e=VobF2Y">1kg.phase3.v5.shapeit2.sas.hg38.tar.gz</a>'],               
            ],
            updates:[
                ['2020.12.6','Provide genotypes of 1000 Genome Project (phase3 v5) based on hg38/GRCh38.']
            ],
            updateImg:UpdateImg,
            naviH:''
        }
    },
//     watch:{
//         updates:function(){
//              var _this = this;
//             _this.$nextTick(function () {
//                 _this.getHeigth()
//             });
//         }
//     },
    // mounted () {
    //     this.getData()
    //     // this.getHeigth()
    // },
    // methods:{
    //     getData(){
    //         var _this=this
    //         _this.download_records=[]
    //         _this.updates=[]
    //         axios.get(api_dir+'json_api_KGGSEE_doc.php')
    //         .then(function (response) {
    //             var jsonObj = JSON.parse(JSON.stringify(response.data));
    //             var dn=jsonObj['download']
    //             for(let i=1;i<dn.length;i++){
    //                 _this.download_records.push([dn[i][0],'<a style="color:#006652;" href="'+dn[i][2]+'">'+dn[i][1]+'</a>',dn[i][3],dn[i][4],dn[i][5]])
    //             }
    //             var updates=jsonObj['updates']
    //             for(let i=1;i<updates.length;i++){
    //                 _this.updates.push(updates[i])
    //             }
    //         // _this.getHeigth()
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    //     },
    //     getHeigth(){
    //         var h = document.getElementById('main').clientHeight;
    //         console.log(h)
    //         // if (h<400){
    //         //     h=400
    //         // }
    //         this.naviH=h+'px'
    //         // document.getElementById('main').style.height=this.naviH
    //     }
    // }

}
</script>

<style scoped>

#document{
    width: 1200px;
}

.main_doc{
    width: 1080px;
    border: solid #E1EAEA 1px;
    position: relative;
  top:80px;
  bottom: 10px;

  /* left: 205px; */
  /* height: 600px; */
  /* margin-left: 15px;
  margin-top: 10px; */
  margin: 15px auto;
  padding-bottom: 10px;
}
.cont{
    width: 850px;
    margin: 10px ;
    margin-left: 40px;
	vertical-align: middle;
}

p {
    color: #000000;
    line-height: 18px;
    font-size: 14px;
    margin:10px 0px 10px 10px;
}

h2{
    font-size: 20px;
    line-height: 20px;
    margin:20px 0px 12px auto;
}

a{
    color:#006652;
}

.download_table{
    width: 850px;
    margin: 10px ;
}
.update_ico{
    height: 18px;
    float: left;
    margin-right: 5px;
    margin-top: 1px;
}

.update_content,.update_title{
    width: 800px;
}

.update_title {
    background: #E0E7D8;
    /* height: 28px; */
}
.update_title p{
    font-weight: bold;
    /* background: #E0E7D8; */
    font-size: 16px;
    line-height: 21px;
}

.update_content p{
    margin-left: 25px;
}

</style>


// WEBPACK FOOTER //
// src/views/download.vue